import { IForceSyncOrderStatusRule } from '../force-sync-order-status-rule.interface';

export class DraftForceSyncRule implements IForceSyncOrderStatusRule {
  showForceSync(): boolean {
    return false;
  }
}
